<template>
    <td-dialog
        v-if="dialogpluginVisible"
        :before-close="languageDialogClose"
        :visible.sync="dialogpluginVisible"
        :width="100 * options.length + 'px'"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        top="18vh"
        :modal="false"
        :show-close="false"
        @cancel="languageDialogClose"
    >
        <td-radio :options="options" v-model="language" keys="id" text="name" @change="handleSetLanguage"></td-radio>
        <span slot="footer"></span>
    </td-dialog>
</template>
<script>
import cookies from 'js-cookie';
export default {
    data() {
        return {
            options: [],
            dialogpluginVisible: false,
            language: cookies.get('tiandy_jp_language') || this.$store.state.language
        };
    },
    created() {
        //监听联动事件
        window.vue.$EventBus.$on('eventLanguage', menu => {
            this.eventLanguage();
        });
        /* 初始化下拉信息 */
        this.options = window.dropdownItem;
    },
    methods: {
        eventLanguage() {
            this.dialogpluginVisible = true;
        },
        handleSetLanguage(lang) {
            this.$i18n.locale = lang;
            this.$store.dispatch('setLanguage', lang);
            document.getElementsByTagName('html')[0].className = lang;
        },
        languageDialogClose() {
            this.dialogpluginVisible = false;
        }
    }
};
</script>

<style scoped>
>>> .el-dialog {
    margin-top: 8vh !important;
    margin-right: 2vh !important;
}
>>> .el-dialog__header {
    height: 0px;
}
>>> .el-dialog__footer {
    height: 0;
    padding: 0;
}
>>> .el-dialog__body {
    height: 30px;
    padding: 7px 20px 0px;
}
</style>
